if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.form.querySelector('[name="id"]').disabled = false;
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');

        if (theme.settings.afterAtc !== 'no-js') {
          this.form.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }
    }

    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      const formData = new FormData(this.form);
      const mainVariantId = formData.get('id');
      const mainQuantity = formData.get('quantity') || 1;

      const mainProperties = {};
      for (const [key, value] of formData.entries()) {
        if (key.startsWith('properties[')) {
          const cleanKey = key.replace('properties[', '').replace(']', '');
          mainProperties[cleanKey] = value;
        }
      }

      const items = [{
        id: parseInt(mainVariantId),
        quantity: parseInt(mainQuantity),
        properties: mainProperties
      }];

      const checkedGifts = document.querySelectorAll('.accessory-add-checkbox:checked');

      checkedGifts.forEach((checkbox) => {
        const container = checkbox.closest('.accessory-item');
        const variantSelect = container ? container.querySelector('.accessory-variant-selector') : null;
        
        let giftVariantId = null;
        let finalPrice = '';

        if (variantSelect) {
          const selectedOption = variantSelect.options[variantSelect.selectedIndex];
          giftVariantId = selectedOption.value;
          finalPrice = selectedOption.getAttribute('data-price-new');
        } else {
          giftVariantId = checkbox.value;
          finalPrice = checkbox.getAttribute('data-price-new');
        }

        if (giftVariantId) {
          const giftProps = {
            '_gift': mainVariantId
          };

          if (finalPrice) {
            giftProps['_discount'] = finalPrice;
          }

          const promoTitle = checkbox.getAttribute('data-promo-title');
          if (promoTitle) {
            giftProps['_title'] = promoTitle;
          }

          // Shopify's native nested cart lines: parent_id points at the variant of the
          // main product added in the same request, so the platform keeps the gift
          // nested under it in the cart, checkout, order and emails, and removes it
          // together with its parent. The _gift property is kept because the cart and
          // discount logic read it.
          items.push({
            id: parseInt(giftVariantId),
            quantity: 1,
            parent_id: parseInt(mainVariantId),
            properties: giftProps
          });
        }
      });

      let sections = 'cart-icon-bubble';
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      const postItems = (lineItems) => fetch(theme.routes.cartAdd, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: lineItems,
          sections: sections,
          sections_url: window.location.pathname
        })
      });

      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();

        let response = await postItems(items);
        let data = await response.json();

        // Shopify can't nest add-ons under bundle products or their components
        // ("Bundle products and add-ons can't be mixed") and refuses the whole
        // request when it happens. Retry as plain lines so the customer still gets
        // what they picked - the _gift property keeps them grouped in the cart.
        if ((!response.ok || data.status) && items.some((lineItem) => lineItem.parent_id)) {
          response = await postItems(items.map((lineItem) => {
            const flat = { ...lineItem };
            delete flat.parent_id;
            return flat;
          }));
          data = await response.json();
        }

        let error = typeof data.description === 'string' ? data.description : data.message;
        if (data.errors && typeof data.errors === 'object') {
          error = Object.entries(data.errors).map((item) => item[1].join(', '));
        }

        if (data.status) this.setErrorMsgState(error);

        if (!response.ok) throw new Error(response.status);

        const mainItemData = data.items ? data.items[0] : data;

        if (theme.settings.afterAtc === 'page') {
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          ProductForm.updateCartIcon(data);

          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          setTimeout(() => {
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(
                data,
                !quickAddDrawer && theme.settings.afterAtc === 'drawer'
              );
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');
              if (cartItems) {
                if (cartItems.dataset.empty === 'true') {
                  window.location.reload();
                } else {
                  cartItems.refresh();
                }
              }
            }
          }, 700);
        }

        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);
        const newCartData = await newCartResponse.json();
        
        const itemInOldCart = oldCartData.items.filter(
          (item) => item.variant_id === mainItemData.variant_id
        )[0];

        if (itemInOldCart) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: mainItemData.variant_id,
              oldQuantity: itemInOldCart.quantity,
              newQuantity: (itemInOldCart.quantity === mainItemData.quantity)
                ? itemInOldCart.quantity : mainItemData.quantity
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: mainItemData.variant_id
            }
          }));
        }
      } catch (error) {
        console.log(error);
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg ? this.errorMsg.textContent : error
          }
        }));
      } finally {
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);
      }
    }

    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }
  }

  customElements.define('product-form', ProductForm);
}

document.addEventListener('DOMContentLoaded', () => {
  const dividebuy = document.querySelector('#dividebuy-softsearch-text');
  const dividebuyTrigger = document.querySelector('.item--dividebuy');

  if (dividebuy && dividebuyTrigger) {
    dividebuyTrigger.addEventListener('click', () => {
      dividebuy.click();
    });
  }

  const ratingElement = document.querySelector('.product-info__rating');
  if (ratingElement) {
      ratingElement.addEventListener('click', (e) => {
          e.preventDefault();

          const reviewsSection = document.querySelector('#reviews details');
          if (reviewsSection) {
              const reviewsPosition = reviewsSection.getBoundingClientRect().top + window.scrollY;
              window.scrollTo({
                  top: reviewsPosition - 200,
                  behavior: 'smooth'
              });
              setTimeout(() => {
                  reviewsSection.open = true;
              }, 100);
          }
      });
  }
});

(function () {
  'use strict';

  var SAVINGS_CLASS = 'sb-bundle-savings';
  var EPS = 0.005; // ignore sub-penny rounding noise

  // "£1,004.39" -> { symbol: "£", value: 1004.39 }. Assumes "." decimal (en-GB / Shopify default).
  function parseMoney(text) {
    if (!text) return null;
    var symbolMatch = text.match(/[^\d.,\s-]+/);
    var symbol = symbolMatch ? symbolMatch[0].trim() : '';
    var value = parseFloat(text.replace(/[^\d.]/g, ''));
    if (isNaN(value)) return null;
    return { symbol: symbol, value: value };
  }

  function formatMoney(value, symbol) {
    return symbol + value.toLocaleString('en-GB', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function enhanceBundle(bundle) {
    var totalBox = bundle.querySelector('.rbr-total-box');
    if (!totalBox) return;

    var finalEl = totalBox.querySelector('.rbr-total-box-price .money, .rbr-total-box-price');
    if (!finalEl) return;
    var final = parseMoney(finalEl.textContent);
    if (!final) return;

    var rawEl = totalBox.querySelector('.rbr-total-box-rawPrice .money, .rbr-total-box-rawPrice');
    var raw = rawEl ? parseMoney(rawEl.textContent) : null;

    var symbol = final.symbol || (raw && raw.symbol) || '£';
    var total = final.value;
    // "Separate selling price" = the struck-through sum of each product's selling price.
    var separate = raw ? raw.value : total;

    // Item-level savings: any product individually on sale shows two prices (was/now).
    var itemSavings = 0;
    bundle.querySelectorAll('.rbr-productNamePrice__price__container').forEach(function (box) {
      var values = Array.prototype.map.call(box.querySelectorAll('.money'), function (m) {
        var p = parseMoney(m.textContent);
        return p ? p.value : null;
      }).filter(function (v) { return v != null; });
      if (values.length >= 2) {
        itemSavings += Math.max.apply(null, values) - Math.min.apply(null, values);
      }
    });

    var buyTogether = Math.max(0, separate - total);
    var totalSaving = buyTogether + itemSavings;
    // "Save X%" — the saving as a share of the separate selling price (RRP-equivalent).
    var savingPct = separate > EPS ? Math.round((totalSaving / separate) * 100) : 0;

    var rows = [{ label: 'Total:', value: formatMoney(total, symbol), mod: 'total' }];
    if (buyTogether > EPS && itemSavings > EPS) {
      // Two genuinely different figures: bundle discount + per-item markdowns.
      rows.push({ label: 'Buy together &amp; save', value: formatMoney(buyTogether, symbol) });
      rows.push({ label: 'Total saving:', value: formatMoney(totalSaving, symbol), mod: 'saving', pct: savingPct });
    } else if (totalSaving > EPS) {
      // Saving comes from one source — show a single highlighted row (no duplicated amount).
      var label = itemSavings > EPS ? 'Total saving:' : 'Buy together &amp; save';
      rows.push({ label: label, value: formatMoney(totalSaving, symbol), mod: 'saving', pct: savingPct });
    }
    if (separate - total > EPS) {
      rows.push({ label: 'Separate selling price ' + formatMoney(separate, symbol), mod: 'separate' });
    }

    // Only touch the DOM when the figures actually change (also breaks the observer feedback loop).
    var sig = rows.map(function (r) { return r.label + r.value + (r.pct || ''); }).join('|');
    if (totalBox.getAttribute('data-sb-sig') === sig) return;
    totalBox.setAttribute('data-sb-sig', sig);

    var box = totalBox.querySelector('.' + SAVINGS_CLASS);
    if (!box) {
      box = document.createElement('div');
      box.className = SAVINGS_CLASS;
      totalBox.appendChild(box);
    }
    box.innerHTML = rows.map(function (r) {
      var cls = 'sb-bundle-savings__row' + (r.mod ? ' sb-bundle-savings__row--' + r.mod : '');
      var pct = r.pct ? '<span class="sb-bundle-savings__pct">Save ' + r.pct + '%</span>' : '';
      var value = r.value != null ? '<span class="sb-bundle-savings__value">' + r.value + '</span>' : '';
      var right = (pct || value) ? '<span class="sb-bundle-savings__amount">' + pct + value + '</span>' : '';
      return '<div class="' + cls + '"><span class="sb-bundle-savings__label">' + r.label + '</span>' + right + '</div>';
    }).join('');

    totalBox.setAttribute('data-sb-enhanced', '');
  }

  // Drop the "| Save 10%" suffix from the CTA, keeping just "Add bundle to cart".
  function cleanButton(bundle) {
    var label = bundle.querySelector('.rbr-addBundleBtn-container span');
    if (!label) return;
    var idx = label.textContent.indexOf('|');
    if (idx === -1) return; // already clean
    var text = label.textContent.slice(0, idx).trim();
    if (text) label.textContent = text;
  }

  function scan() {
    document.querySelectorAll('[id^="rbr-bundle-"]').forEach(function (bundle) {
      enhanceBundle(bundle);
      cleanButton(bundle);
    });
  }

  var scheduled = false;
  function scheduleScan() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      scan();
    });
  }

  function init() {
    scan();
    new MutationObserver(scheduleScan).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();